import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SearchComponent.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

export const SearchComponent = ({ searchQuery, setSearchQuery, onSearch }) => {
    const [hintIndex, setHintIndex] = useState(0);

    const hints = [
        "iPhone 14",
        "Honda Activa",
        "Study Table",
        "Gaming Laptop",
        "Office Chair",
        "Second-hand Bike",
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setHintIndex((prev) => (prev + 1) % hints.length);
        }, 2500);
        return () => clearInterval(interval);
    }, [hints.length]);

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchQuery.trim().length < 2) return;

        onSearch(); // 🔥 trigger parent search
    };

    return (
        <div style={{ padding: '24px 0' }}> {/* Added padding for visibility */}

            <form className="hero-search-bar" onSubmit={handleSearch}>
                <div className="input-wrapper">
                    <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="hero-search-input"
                    />

                    {!searchQuery && (
                        <div className="search-hint-wrapper">
                            <span className="hint-prefix">Try</span>
                            <span key={hints[hintIndex]} className="search-hint">
                                "{hints[hintIndex]}"
                            </span>
                        </div>
                    )}
                </div>

                <button type="submit" className="hero-search-btn">
                    <FontAwesomeIcon icon={faSearch} />
                </button>
            </form>
        </div>
    );
};